import Head from 'next/head'
import { ReactNode } from 'react'
import DefaultViewport from './DefaultViewport'
import OgTags from './OgTags'
import TwitterTags from './TwitterTags'

type CommonHeadProps = {
  title: string
  description: string
  url?: string
  imageSource?: string
  children?: ReactNode
  canonicalUrl?: string
}

const CommonHead = ({
  title,
  description,
  url,
  imageSource,
  children,
  canonicalUrl,
}: CommonHeadProps) => {
  return (
    <>
      <DefaultViewport />
      <OgTags title={title} description={description} imageSource={imageSource} url={url} />
      <TwitterTags title={title} description={description} imageSource={imageSource} />
      <Head>
        <title>{title}</title>
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} key="canonical" />}
        {children}
      </Head>
    </>
  )
}

export default CommonHead
